import React from 'react';
import { Headline } from '@oneaudi/unified-web-components';
import { CarInfoContainer, VehicleDetailWrapper } from './styles/CarinfoWrapper.styles';
import { AvailableBadge } from './AvailableBadge';
import { FinanceRethink } from './finance/FinanceRethink';
import { KeyFeaturesWrapper } from './KeyFeaturesWrapper';
import { WarrantyInfoLink } from './WarrantyInfoLink';
import { InfoItemsWrapper } from './InfoItemsWrapper';
import { DealerInfoRethink } from './dealerInfo/DealerInfoRethink';
export const CarinfoWrapper = ({ vehicle, dynamicFinancingValues, updateDynamicFinancingValues, }) => {
    const { basic } = vehicle;
    return (React.createElement(CarInfoContainer, { "data-test-id": "pdp" },
        React.createElement(VehicleDetailWrapper, null,
            React.createElement(Headline, { tag: "h2", variant: {
                    order: '2',
                    type: 'headline',
                    weight: 'bold',
                } }, basic.symbolicCarline.description),
            React.createElement(Headline, { tag: "h3", variant: {
                    order: '4',
                    type: 'headline',
                    weight: 'normal',
                } }, basic.modelCode.description)),
        React.createElement(FinanceRethink, { vehicle: vehicle, dynamicFinancingValues: dynamicFinancingValues, updateDynamicFinancingValues: updateDynamicFinancingValues }),
        React.createElement(AvailableBadge, { vehicleBasic: vehicle.basic }),
        React.createElement(DealerInfoRethink, { vehicleBasic: vehicle.basic }),
        React.createElement(KeyFeaturesWrapper, { vehicle: vehicle.basic }),
        React.createElement(WarrantyInfoLink, { vehicle: vehicle }),
        React.createElement(InfoItemsWrapper, { vehicleBasic: vehicle.basic })));
};
